import FetchHelper from '../../helpers/fetchHelper';
import notification from '../../components/notification';

const actions = {
  CLEAR_INFORME_GENERAL: 'CLEAR_INFORME_GENERAL',
  clearAll: () => ({ type: actions.CLEAR_INFORME_GENERAL }),

  SET_INFORME_GENERAL: 'SET_INFORME_GENERAL',
  setReportGeneral: (report) => ({ type: actions.SET_INFORME_GENERAL, payload:report }),

  SET_URL: 'SET_URL',
  setPrevUrl: (url) => ({ type: actions.SET_URL, payload: url }),



}
export default actions;
